
declare var ROOT: any;

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import { gsap } from 'gsap';
import { ScrollToPlugin,ScrollTrigger } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);
ScrollToPlugin.autoKillThreshold = 1;

export default class {
  constructor() {
    this.init();
  }

  init() {
    var self = this;
    this.setAnchorLink();
    this.setHorizontalScroll();

    // ボタンのSCROLL
    var scene:any = ScrollTrigger.create({
      trigger: ".section-message",
      start: "top center",
      endTrigger: ".section-contact",
      end: "top center",
      onToggle: ({progress, direction, isActive}) => {
        if(isActive){
          document.querySelector(".bottom-fix").classList.add("active")
        }else{
          document.querySelector(".bottom-fix").classList.remove("active")
        }
      },
      // markers: true // マーカー表示
    })

    // 画像の読み込み完了後に高さが変わるのでアップデート
    document.addEventListener('lazybeforeunveil', function(e){
      scene.refresh() ;
      window.dispatchEvent(new Event('resize'));
    })

    document.querySelectorAll(".scrlUpFade").forEach((item)=>{
      gsap.from(item, {
        y: 60,
        opacity:0,
        duration: 1,
        scrollTrigger: {
          trigger: item,
          start: 'top 75%',
          // markers: true // マーカー表示
        }
      })
    })
    // gsap.to('.fix-holder', { // 動かしたい要素は".a"
    //   y: -60, // 右方向に500動く
    //   duration: 1, // アニメーションは1秒間
    //   scrollTrigger: {
    //     trigger: '.section-message',
    //     start: 'top 0%', // アニメーション開始位置
    //     end: 'bottom 100%', // アニメーション終了位置
    //     scrub: true, // アニメーションをスクロール位置にリンクさせる
    //     markers: true // マーカー表示
    //   }
    // })
  }

  setHorizontalScroll() {
    /* 固定ヘッダーでの横スクロール対応
     *********************************/
    if (!ROOT.isSp) {
      var preLeft = 0;
      var targets = document.querySelectorAll('.header .menu-inner');
      window.addEventListener('scroll',()=>{
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft
        if (preLeft != scrollLeft) {
          gsap.set(targets,{'left': -scrollLeft})
        }
        preLeft = scrollLeft;
      });
    }
  }
  setAnchorLink() {
    document.addEventListener("click",(e)=>{
      var target:any=e.target;
      var idStr=target.getAttribute("href");
      if(idStr && idStr.indexOf("#")===0 && !target.classList.contains('no-scroll')){
        e.preventDefault()
        this.gotoScroll(idStr);
        return true;
      }
    })
  }
  gotoScroll(el) {
    let target:any = document.querySelector(el);
    if(!target) target = document.querySelector("body");
    target.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }
}
